import type { ReadonlySignal } from '@preact/signals'
import { createContext } from 'preact'
import { useContext } from 'preact/hooks'
import type { GameClient, ViewState } from '#contract'
import { assert } from '#shared'

/** What the UI knows about the game: the client for commands and its view as a signal. */
export interface ClientBridge {
  /** `null` until the engine chunk has loaded. */
  readonly client: GameClient | null
  /** Mirrors `client.view`; holds the initial (or failed) view before that. */
  readonly view: ReadonlySignal<ViewState>
}

export const ClientContext = createContext<ClientBridge | null>(null)

export function useClientBridge(): ClientBridge {
  const bridge = useContext(ClientContext)
  assert(bridge, 'The UI needs a <ClientContext.Provider> above it')
  return bridge
}

/** The game client for sending commands, or `null` while the engine still loads. */
export function useClient(): GameClient | null {
  return useClientBridge().client
}
